import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8","key":"svg-0"}]]

const IconLetterBSmall = createReactComponent('outline', 'letter-b-small', 'LetterBSmall', __iconNode);

export default IconLetterBSmall;